//   发现好货
export default [{
    path: '/myFocus',
    name: 'myFocus',
    meta: {
      index: 2
    },
    component: () => import('@/views/myFocus/index')
  }]
  